// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"1b3b95db","361":"71b9a55e","453":"6fb600e6","732":"76dfbdd1","734":"b36536f9","842":"9381b95e","977":"dfbc2db7"}[chunkId] + ".chunk.js";
};